export async function uploadAssayPhotoToS3({putUrl, file, contentType}) {
    const response = await fetch(putUrl, {
        method: 'PUT',
        headers: {'Content-Type': contentType},
        body: file,
    })

    if (!response.ok) {
        throw new Error(`S3 upload failed: ${response.status} ${response.statusText}`)
    }
}